<template>
	<div>
		<button
			@click="$emit('click', $event)"
			:class="classList"
			:type="type"
			:disabled="disabled"
		>
			<span class="content"><slot></slot></span>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: 'button',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		block: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: undefined,
		},
		small: {
			type: Boolean,
			default: false,
		},
		medium: {
			type: Boolean,
			default: false,
		},
		xLarge: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classList() {
			return [
				'btn',
				this.color,
				{ 'btn--disabled': this.disabled },
				{ 'btn--block': this.block },
				{ 'btn--small': this.small },
				{ 'btn--medium': this.medium },
				{ 'btn--x-large': this.xLarge },
			];
		},
	},
};
</script>

<style scoped>
.btn {
	display: inline-block;
	justify-content: center;
	align-items: center;
	min-width: 5em;
	height: 2.5rem;
	padding: 0 0.5rem;
	border-radius: 0.1875rem;
	border: 0.0625rem solid transparent;
	background-color: #f5f5f5;
	color: #222;
	font-size: 0.875rem;
	line-height: 2.375rem;
	vertical-align: middle;
	text-align: center;
	user-select: none;
}

.btn.primary {
	background-color: #222;
	color: #fff;
}

.btn.secondary {
	background-color: #fff;
	border-color: #222;
	color: #222;
}

.btn.thirdly {
	background-color: #f5f5f5;
	border-color: #222;
	color: #222;
}

.btn.link {
	min-width: auto;
	padding: 0;
	color: #666;
	border-radius: 0;
	border-bottom: 1px solid #666;
	background-color: transparent;
}

.btn--small {
	height: 1.5625rem;
	font-size: 0.8125rem;
	line-height: 1.4375rem;
}

.btn--medium {
	font-size: 0.875rem;
}

.btn--x-large {
	height: 3.1875rem;
	font-size: 1.0625rem;
	line-height: 3.0625rem;
}

.btn--block {
	display: block;
	width: 100%;
}

.btn--disabled,
.btn:disabled {
	border-color: transparent !important;
	background-color: #b3b3b3 !important;
	color: #f5f5f5 !important;
	cursor: no-drop !important;
}
</style>
